import React from 'react';
import Link from '@sg/assests/svg/link-icon.svg';

/** In Dev project card title — matches page-level title markup (not commonPageMethod rendTitle). */
export const rendCardTitle = (data: {
  title?: string;
  tips?: string;
  titleSize?: string;
  tipSize?: string;
  url?: string;
}) => (
  <>
    <div className="dbo-card-title">
      <div
        className="dbo-card-titles"
        style={{ fontSize: data?.titleSize, fontWeight: '700' }}
      >
        {data?.title}
      </div>
      <div className="dbo-card-title-sub" style={{ fontSize: data?.tipSize }}>
        &nbsp;&nbsp;{data?.tips}
        {data?.url && (
          <span style={{ fontSize: data?.tipSize }}>
            <img
              src={Link}
              alt="Link"
              className="dbs-title-icon-link"
              onClick={(e) => {
                e?.stopPropagation();
                e?.preventDefault();
                window.open(data?.url);
              }}
            />
          </span>
        )}
      </div>
    </div>
  </>
);
